import React from 'react'
import Image from '@components/atoms/Image'
import ProductSlider from '@components/molecules/ProductSlider'
import { ProductImage } from '@interfaces/product'

interface UnrelatedProduct {
  product_name: string
  price: string
  url: string | { text: string; url: string }
  featured_image: ProductImage
  hover_image?: ProductImage
}

export interface UnrelatedProductsProps {
  unrelated_products: UnrelatedProduct[]
}

const normalizeUrl = (url: string | { url: string }): string => (typeof url === 'string' ? url : url.url)

const UnrelatedProducts: React.FC<UnrelatedProductsProps> = ({ unrelated_products }) => {
  const normalizedProducts = unrelated_products.map((product) => ({
    ...product,
    url: normalizeUrl(product.url), // Normalize the URL
  }))

  const slides = normalizedProducts.map((unrelated_product, index) => (
    <div className="pb-3" key={index}>
      <a
        href={unrelated_product.url}
        aria-label={unrelated_product.product_name}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
        <div className="flex flex-col h-[364px] bg-white rounded-large shadow-md">
          <div className="flex rounded-t-large h-[304px] bg-[#f2f2f2] justify-center group overflow-hidden">
            <Image
              {...unrelated_product.featured_image}
              classes={
                'w-full h-full object-contain rounded-t-large aspect-square transition-transform duration-300 ease-in-out group-hover:scale-110'
              }
              srcWidths={{ sm: 304, md: 304, lg: 304, xl: 304, '2xl': 304 }}
            />
          </div>
          <div className="flex flex-wrap px-7 py-5">
            <h3 className="text-sm w-8/12 font-medium truncate">{unrelated_product.product_name}</h3>
            <p className="text-sm w-4/12 font-bold text-right">
              {unrelated_product.price.replace(/\s[A-Za-z]{3}$/i, '')}
            </p>
          </div>
        </div>
      </a>
    </div>
  ))

  return (
    <ProductSlider
      slides={slides}
      paginationClass="unrelated-products-pagination"
      navigationPrevClass="unrelated-products-button-prev"
      navigationNextClass="unrelated-products-button-next"
    />
  )
}

export default UnrelatedProducts
